'use client';

import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          content: 'group-[.toast]:!flex-1',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          closeButton:
            'group-[.toast]:text-foreground group-[.toast]:!static group-[.toast]:!order-last group-[.toast]:!ml-auto group-[.toast]:!top-auto group-[.toast]:!left-auto group-[.toast]:!right-auto group-[.toast]:!transform-none group-[.toast]:!bg-transparent group-[.toast]:!border-0 group-[.toast]:hover:!bg-transparent',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
